
import { Component, Vue } from "vue-property-decorator";
import Flag from "@/components/common/Flag.vue";
@Component({
  components: { Flag },
})
export default class Prizes extends Vue {}
